import React from 'react';

import { useIntl } from 'react-intl-next';

import {
	allTypeFilterValueKeys,
	universalTypeFilterId,
	type UniversalTypeFilterMapping,
} from '../../../../../common/constants/filters';
import {
	type ProductKeys,
	ProductKeys as ProductKeysEnum,
} from '../../../../../common/constants/products';
import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { getTypeMapping } from '../../../../../common/utils/filters/constants';
import { useUniversalSelectFilter } from '../../../../../controllers/filters';
import { useSelectedProduct } from '../../../../../controllers/store';

import { i18n } from './messages';

const getOptionsToProducts = (typeMapping: UniversalTypeFilterMapping) => {
	const optionsToProducts: Record<string, ProductKeys[]> = {};
	allTypeFilterValueKeys.forEach((type) => {
		optionsToProducts[type] = typeMapping[type].products || [];
	});
	return optionsToProducts;
};

const TypeFilter = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const typeMapping = getTypeMapping();
	const optionsToProducts = getOptionsToProducts(typeMapping);
	const [productSelected] = useSelectedProduct();

	const [
		filterData,
		{ setOption, loadInitialOptions, setLookupInput, clearLookupInput, clearOptions },
	] = useUniversalSelectFilter({
		filterId: universalTypeFilterId,
		optionsToProducts: optionsToProducts,
	});

	if (!filterData) {
		return null;
	}
	// Do not show TypeFilter for Atlas since that is handled by Noun filters
	if (productSelected === ProductKeysEnum.Atlas) {
		return null;
	}

	const { options, lookupInput, selectedOptions } = filterData;

	return (
		<SelectFilter
			onDropdownOpen={loadInitialOptions}
			onDropdownClose={clearLookupInput}
			onSelectChange={setOption}
			options={options}
			selectedOptions={selectedOptions}
			label={formatMessage(i18n.type)}
			placeholder={formatMessage(i18n.filterTypePlaceholder)}
			filterOrControlId={universalTypeFilterId}
			searchInput={lookupInput}
			onSearchInputChange={setLookupInput}
			isSearchable
			onClearOptions={clearOptions}
			testId="universal-type-filter"
		/>
	);
};

export default TypeFilter;
